module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_06.f3dcd0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_06.png
// module id = QmyA
// module chunks = 1